/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { forwardRef } from 'react';
import { Box, Dialog, Slide } from '@mui/material';
import type { TransitionProps } from '@mui/material/transitions';

type MobileMenuDialogProps = {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
};

// eslint-disable-next-line prefer-arrow-callback
const LeftSlide = forwardRef(function LeftSlide(
  props: TransitionProps & { children: React.ReactElement<any, any> },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="right" ref={ref} {...props} />;
});

export function MobileMenuDialog({ open, onClose, children }: MobileMenuDialogProps) {
  return (
    <Dialog
      id='mobile-menu-dialog'
      fullScreen
      open={open}
      onClose={onClose}
      TransitionComponent={LeftSlide}
      sx={{ zIndex: 1199 }}
      PaperProps={{
        sx: {
          bgcolor: 'common.white',
          width: '100%',
          height: '100dvh',
          p: (t) => ({ xs: t.spacing(1.25), sm: t.spacing(2) }),
          zIndex: 1199,
          position: 'relative',
        },
      }}
      slotProps={{
        backdrop: {
          sx: {
            bgcolor: 'rgba(0,0,0,0.24)',
            zIndex: 1199,
          },
        },
      }}
      // Accessibility
      aria-label="Mobile navigation menu"
    >
      <Box sx={{ height: '100%', overflowY: 'auto' }}>
        {children}
      </Box>
    </Dialog>
  );
}
